import PropTypes from 'prop-types';
import React from 'react';
import { addMinutes, compareAsc } from 'date-fns';
import { STATUS_DENIED, STATUS_OKAY, STATUS_WAITING } from '../utlities/core.constants';
import StatusBar from './StatusBar.component';

export default function UserRequestStatus({request = null, entity = null, primaryPoc = null}){
  if(!entity || !primaryPoc){
    return <div />;
  }

  if(request.decisionDate && request.isApproved === false) {
    return (
      <StatusBar status={STATUS_DENIED} title="Request denied" description={`Your request has been sent to the ${entity.name} admin and has been denied. If you need help and/or have any questions, please reach out to ${primaryPoc?.email}.`} />
    );
  }

  if(!request.decisionBy && compareAsc(new Date(), addMinutes(request.createdDate, 15)) > 0){
    return (
      <StatusBar status={STATUS_WAITING} title="Waiting on request" description={`Your request has been sent to the ${entity.name} admin and is awaiting approval. If you need help and/or have any questions, please reach out to ${primaryPoc?.email}.`} />
    );
  }

  if(!request.decisionBy && request.createdDate){
    return (
      <StatusBar status={STATUS_OKAY} title="Request successfully submitted" description={`Your request has been sent to the ${entity.name} admin and is awaiting approval. If you need help and/or have any questions, please reach out to ${primaryPoc?.email}.`} />
    );
  }
}

UserRequestStatus.propTypes = {
  request: PropTypes.object,
  entity: PropTypes.object,
  primaryPoc: PropTypes.object
}
